var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "survey-react-ui";
var SurfacePlaceholder = /** @class */ (function (_super) {
    __extends(SurfacePlaceholder, _super);
    function SurfacePlaceholder(props) {
        return _super.call(this, props) || this;
    }
    SurfacePlaceholder.prototype.render = function () {
        return (React.createElement("div", { className: "svc-surface-placeholder" },
            React.createElement("div", { className: "svc-surface-placeholder__image svc-surface-placeholder__image--" + this.props.name }),
            React.createElement("div", { className: "svc-surface-placeholder__text" },
                React.createElement("div", { className: "svc-surface-placeholder__title" }, this.props.placeholderTitleText),
                React.createElement("div", { className: "svc-surface-placeholder__description" }, this.props.placeholderDescriptionText))));
    };
    return SurfacePlaceholder;
}(React.Component));
export { SurfacePlaceholder };
ReactElementFactory.Instance.registerElement("svc-surface-placeholder", function (props) {
    return React.createElement(SurfacePlaceholder, props);
});
